export default "__VITE_ASSET__DTMTbAQ9__"